// removed by extract-text-webpack-plugin
module.exports = {"icon":"_26byASnXOafzgZ6UJ2cDa5","folded":"_3oisWi-QpfFMbghUa9MFfG","unfolded":"_3IRplrNDgjfsw0ceyUsPfP"};